/**
 * Brand singleton (frontend).
 *
 * Mirrors backend/core/brand.py. Any UI string that mentions the product
 * name, tagline, domain, or social handle should import from here.
 *
 * Override at build time with REACT_APP_BRAND_* env vars (white-labelling).
 * To rebrand the whole product:
 *   1. Edit the defaults below (or set REACT_APP_BRAND_* env vars).
 *   2. Edit the matching backend constants in /app/backend/core/brand.py.
 *   3. Rebuild + redeploy.
 */
const env = (k, fallback) =>
    (typeof process !== "undefined" && process.env && process.env[k]) || fallback;

export const BRAND = {
    name: env("REACT_APP_BRAND_NAME", "RealWorld Outdoors"),
    nameWordOne: env("REACT_APP_BRAND_NAME_ONE", "RealWorld"),
    nameWordTwo: env("REACT_APP_BRAND_NAME_TWO", "Outdoors"),
    tagline: env("REACT_APP_BRAND_TAGLINE", "outdoors, together."),
    domain: env("REACT_APP_BRAND_DOMAIN", "realworldadventuring.com"),
    twitter: env("REACT_APP_BRAND_TWITTER", "@realworldoutdoors"),
    // Self-contained circular badge — no surrounding box / colour fill needed.
    logoUrl: env("REACT_APP_BRAND_LOGO", "/logo.png"),
    footerLine: env(
        "REACT_APP_BRAND_FOOTER_LINE",
        "A social network for people who actually go outside. Find real adventures shared by real people, then go do them."
    ),

    // ---- Legal block (used by /terms, /privacy, /community-guidelines) ----
    // Swap any of these in one place to keep all legal pages in sync.
    legal: {
        entity: env("REACT_APP_LEGAL_ENTITY", "RealWorld Outdoors, Inc."),
        jurisdiction: env("REACT_APP_LEGAL_JURISDICTION", "State of Oklahoma, USA"),
        venue: env("REACT_APP_LEGAL_VENUE", "the state and federal courts located in Oklahoma County, Oklahoma"),
        contactEmail: env("REACT_APP_LEGAL_EMAIL", "realworldadventure@realworldadventuring.com"),
        // Update whenever the policies are materially changed.
        effectiveDate: env("REACT_APP_LEGAL_EFFECTIVE_DATE", "February 9, 2026"),
        // Mailing address shown on Privacy + DMCA. Override via env when known.
        mailingAddress: env(
            "REACT_APP_LEGAL_MAILING_ADDRESS",
            "RealWorld Outdoors, Inc. · Oklahoma, USA"
        ),
        // Click-wrap consent version — must match backend `core/brand.TERMS_VERSION`.
        // Bump when policies materially change to invalidate prior consent.
        termsVersion: env("REACT_APP_TERMS_VERSION", "2026-02-09"),
    },
};

export default BRAND;
